export default "/images/shildikAmedia.svg?80e3418d3c7cf47d2165d9cba752ebc5";